import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import ButtonDS22 from '../../../common/components/ButtonDS22';
import IconDS22 from '../../../common/components/IconDS22';

export type MapToggleButtonProps = {
  mapOpen: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

const MapToggleButton: FC<MapToggleButtonProps> = ({ mapOpen, onToggle, disabled }) => {
  const [t] = useTranslation('search-page');

  return (
    <ButtonDS22
      size="medium"
      rounded
      onClick={onToggle}
      shadow
      disabled={disabled}
    >
      <IconDS22
        id={`${mapOpen ? 'list' : 'map'}`}
        size="l"
      />
      {t(`map-toggle-button--${mapOpen ? 'list' : 'map'}`)}
    </ButtonDS22>
  );
};

export default MapToggleButton;
